<template>
  <div class="page-container">
    <el-card shadow="never" class="main-card">
      <!-- 查询条件区 + 状态 -->
      <div class="search-bar">
        <el-select v-model="queryCon.devModelId" placeholder="设备型号" clearable style="width: 240px">
          <el-option v-for="item in deviceModels" :key="item.id" :label="item.devModel + ' ' + item.devName" :value="item.id" />
        </el-select>
        <el-input v-model="queryCon.devNo" placeholder="请输入设备号" clearable style="width: 220px"
          @keyup.enter="handler.queryDeviceHandler" />
        <el-input v-model="queryCon.devBatchNo" placeholder="批次号" clearable style="width: 160px" />
        <el-button-group>
          <el-button type="primary" :icon="Search" @click="handler.queryDeviceHandler">查询</el-button>
          <el-button :icon="RefreshRight" @click="resetQueryCon">重置</el-button>
        </el-button-group>
      </div>

      <!-- 设备卡片网格 -->
      <div class="card-grid-wrapper">
        <div class="card-grid" v-loading="tableLoading">
        <el-card v-for="(device, index) in deviceData" :key="device.devNo" class="device-card" shadow="hover"
          :body-style="{ padding: '14px' }">
          <!-- 设备号 + 在线状态（同一行对齐） -->
          <div class="card-header">
            <el-link type="primary" :underline="false" class="dev-no-link"
              @click="handler.loadDevChannels(device, index)">
              {{ device.devNo }}
            </el-link>
            <el-tag :type="device.devOnlineStatus === 1 ? 'success' : 'danger'" size="small" effect="dark" round
              class="card-status-tag">
              {{ device.devOnlineStatus === 1 ? '在线' : '离线' }}
            </el-tag>
          </div>

          <!-- 设备信息 -->
          <div class="card-info">
            <div class="info-row">
              <span class="info-label">名称</span>
              <span class="info-value">{{ device.devName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">型号</span>
              <span class="info-value">{{ device.devModel || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">批次</span>
              <span class="info-value">{{ device.devBatchNo || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">路数</span>
              <span class="info-value">{{ device.devChannelCount ?? 0 }} 路</span>
            </div>
          </div>

          <!-- 底部操作区 -->
          <div class="card-actions">
            <el-button type="primary" link size="small" @click="handler.loadDevChannels(device, index)">
              控制面板 →
            </el-button>
          </div>
        </el-card>
      </div>

      <!-- 空状态 -->
      <el-empty v-if="!tableLoading && deviceData.length === 0" description="暂无设备数据" :image-size="80" />
    </div>

      <!-- 页脚：状态 + 分页 -->
      <div class="footer-bar">
        <div class="status-bar">
          <div class="status-item">
            <span class="status-dot" :class="socketStatus === '已连接' ? 'connected' : 'disconnected'" />
            <span class="status-label">服务器</span>
            <el-tag :type="socketStatus === '已连接' ? 'success' : 'info'" size="small" effect="plain">
              {{ socketStatus }}
            </el-tag>
          </div>
          <div class="status-item">
            <span class="status-dot" :class="deviceControlStatus !== '-' ? 'active' : ''" />
            <span class="status-label">指令</span>
            <el-tag :type="deviceControlStatus === '-' ? 'info' : 'warning'" size="small" effect="plain">
              {{ deviceControlStatus }}
            </el-tag>
          </div>
        </div>
        <el-pagination background v-model:current-page="queryCon.currentPage" v-model:page-size="queryCon.pageSize"
          :page-sizes="pagination.pageInfo.pageSizes" layout="total, sizes, prev, pager, next" :total="pagination.pageInfo.total"
          @size-change="pagination.handleSizeChange" @current-change="pagination.handleCurrentChange" />
      </div>
    </el-card>

    <!-- 设备控制抽屉 -->
    <el-drawer v-model="drawer" :with-header="true" size="420px" direction="rtl"
      :before-close="handler.onDrawerClose">
      <template #header>
        <div class="drawer-header">
          <span class="drawer-title">设备控制面板</span>
          <el-tag v-if="selectedDeviceObj" type="primary" effect="plain" size="small">
            {{ selectedDeviceObj.devNo }}
          </el-tag>
        </div>
      </template>

      <template #default>
        <div v-loading="loading" class="drawer-body">
          <!-- 设备概要 -->
          <div v-if="selectedDeviceObj" class="device-summary">
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="设备名称">{{ selectedDeviceObj.devName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="设备型号">{{ selectedDeviceObj.devModel || '-' }}</el-descriptions-item>
              <el-descriptions-item label="控制路数">{{ selectedDeviceObj.devChannelCount ?? 0 }}</el-descriptions-item>
              <el-descriptions-item label="在线状态">
                <el-tag :type="selectedDeviceObj.devOnlineStatus === 1 ? 'success' : 'danger'" size="small">
                  {{ selectedDeviceObj.devOnlineStatus === 1 ? '在线' : '离线' }}
                </el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <el-divider />

          <!-- 通道列表 -->
          <el-empty v-if="!loading && devChannels.length === 0" description="该设备暂无通道数据" :image-size="60" />

          <div v-else class="channel-list">
            <div v-for="channelItem in devChannels" :key="channelItem.id" class="channel-row">
              <div class="channel-no">
                <el-tag type="info" effect="plain" round size="small">CH{{ channelItem.channelNo }}</el-tag>
              </div>
              <div class="channel-switch">
                <el-switch v-model="channelItem.status.code" :active-value="1" :inactive-value="0" inline-prompt
                  active-text="开" inactive-text="关" size="large"
                  @change="handler.onSwitchChange(channelItem)" />
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="drawer-footer">
          <el-button type="success" :icon="Select" @click="handler.batchAllOn" :disabled="devChannels.length === 0">
            一键全开
          </el-button>
          <el-button type="danger" :icon="CloseBold" @click="handler.batchAllOff" :disabled="devChannels.length === 0">
            一键全关
          </el-button>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<style lang="css" scoped>
@import "../../assets/styles/common.css";

/* ========== 卡片网格：占据剩余高度，内部滚动 ========== */
.card-grid-wrapper {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 12px;
  padding: 0 4px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 16px;
  padding-bottom: 8px;
}

/* ========== 设备卡片 ========== */
.device-card {
  border-radius: 10px;
  transition: all 0.3s ease;
  border: 1px solid #ebeef5;
}

.device-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  border-color: #c6d9f1;
}

/* 设备号 + 在线状态 同行对齐 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.dev-no-link {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  letter-spacing: 0.5px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-status-tag {
  flex-shrink: 0;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-row {
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 1.6;
}

.info-label {
  color: #909399;
  min-width: 36px;
  flex-shrink: 0;
}

.info-label::after {
  content: ':';
  margin-right: 6px;
}

.info-value {
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-actions {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #f2f3f5;
  text-align: right;
}

/* ========== 页脚 ========== */
.footer-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}

/* ========== 状态栏 ========== */
.status-bar {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #606266;
}

.status-label {
  color: #909399;
  font-size: 13px;
}

/* 状态指示点 */
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #c0c4cc;
  flex-shrink: 0;
}

.status-dot.connected {
  background-color: #67c23a;
  box-shadow: 0 0 6px rgba(103, 194, 58, 0.6);
  animation: pulse-green 2s infinite;
}

.status-dot.disconnected {
  background-color: #f56c6c;
}

.status-dot.active {
  background-color: #e6a23c;
  animation: pulse-orange 1.5s infinite;
}

@keyframes pulse-green {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

@keyframes pulse-orange {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* ========== 抽屉 ========== */
.drawer-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.drawer-title {
  font-size: 16px;
  font-weight: 600;
}

.drawer-body {
  padding: 0 4px;
}

.device-summary {
  margin-bottom: 8px;
}

.channel-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.channel-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #fafafa;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.channel-row:hover {
  background: #f0f5ff;
}

.channel-no {
  flex-shrink: 0;
}

.channel-switch {
  flex-shrink: 0;
}

.drawer-footer {
  display: flex;
  gap: 12px;
  justify-content: center;
}

/* ========== 滚动条微调 ========== */
.card-grid-wrapper::-webkit-scrollbar {
  width: 4px;
}

.card-grid-wrapper::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 2px;
}
</style>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from "vue";
import { ElMessage } from "element-plus";
import { Search, RefreshRight, Select, CloseBold } from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import "@/assets/styles/crud-page.css";
import { deviceApi, deviceModelApi } from "@/api/deviceApi.js";
import WebSocketClient from "@/core/websocket";
import { getUserInf } from "@/shard/login-info-manager";

// ---------- 状态 ----------
const loading = ref(false);
const tableLoading = ref(false);
const drawer = ref(false);

// ---------- 数据 ----------
const deviceData = ref([]);
const deviceModels = ref([]);
const selectedDeviceObj = ref(null);
const selectedDeviceIndex = ref(null);
const controledDevice = new Map();
const devChannels = ref([]);

// ---------- WebSocket ----------
let socket = null;
const socketStatus = ref("-");
const deviceControlStatus = ref("-");

// ---------- 查询 & 分页 ----------
const queryCon = reactive({ devNo: "", devModelId: null, devBatchNo: "", pageSize: 20, currentPage: 1 });

const pagination = {
  pageInfo: reactive({
    total: 0,
    pageSizes: [20, 30, 50, 100],
  }),
  handleSizeChange: (val) => {
    queryCon.pageSize = val;
    handler.queryDeviceHandler();
  },
  handleCurrentChange: (val) => {
    queryCon.currentPage = val;
    handler.queryDeviceHandler();
  },
};

const resetQueryCon = () => {
  queryCon.devNo = "";
  queryCon.devModelId = null;
  queryCon.devBatchNo = "";
  queryCon.pageSize = 20;
  queryCon.currentPage = 1;
  handler.queryDeviceHandler();
};

// ---------- WebSocket 初始化 ----------
const initWebSocket = () => {
  const token = getUserInf().authToken;
  const params = new URLSearchParams({
    "X-Client-Type": "SRC-WEB",
    "X-Auth-Type": "tokenAuth",
    accessToken: token,
  });

  const wsUrl = `${process.env.VUE_APP_WEBSOCKET_URL}?${params.toString()}`;
  socket = new WebSocketClient(wsUrl);

  socket.onOpen = () => {
    console.log("WebSocket 连接成功");
    socketStatus.value = "已连接";
  };

  socket.onClose = () => {
    console.log("WebSocket 连接关闭");
    socketStatus.value = "已断开";
  };

  socket.onMessage = (data) => {
    let resData = JSON.parse(data);
    console.log("WS 消息:", data);

    switch (resData.wsMessageType?.code) {
      case "COMMAND_DELIVER":
        deviceControlStatus.value = resData.status?.desc || "指令已下发";
        break;
      case "DEVICE_FEEDBACK":
        deviceControlStatus.value = "设备已执行";
        break;
      default:
        break;
    }
  };
};

// 加载设备型号选项
const loadDeviceModels = async () => {
  try {
    const { data } = await deviceModelApi.queryList();
    deviceModels.value = data.result || [];
  } catch (err) {
    console.error("加载设备型号失败", err);
  }
};

// ---------- 生命周期 ----------
onMounted(() => {
  loadDeviceModels();
  handler.queryDeviceHandler();
  initWebSocket();
});

onUnmounted(() => {
  if (socket) {
    socket.close();
  }
});

// ---------- 业务逻辑 ----------
const handler = {
  // 查询设备列表
  queryDeviceHandler() {
    tableLoading.value = true;
    deviceApi
      .query(queryCon)
      .then((response) => {
        if (response.data.errorCode === "00000") {
          pagination.pageInfo.total = response.data.result.total;
          const records = response.data.result.records || [];
          records.forEach((item) => {
            item.channels = [];
            for (let i = 1; i <= item.devChannelCount; i++) {
              item.channels.push({ channelNo: i, status: 0 });
            }
          });
          deviceData.value = records;
        } else {
          ElMessage.error(`系统异常 [ErrorCode: ${response.data.errorCode}]`);
        }
      })
      .finally(() => {
        tableLoading.value = false;
      });
  },

  // 加载设备通道
  async loadDevChannels(rowData, index) {
    drawer.value = true;
    selectedDeviceIndex.value = index;
    selectedDeviceObj.value = rowData;
    loading.value = true;

    try {
      const { data } = await deviceApi.listChannels({ devNo: rowData.devNo });
      devChannels.value = data.result || [];
    } catch (err) {
      ElMessage.error("加载通道数据失败");
      console.error(err);
    } finally {
      loading.value = false;
    }
  },

  // 单个通道开关切换
  onSwitchChange(channel) {
    if (!socket || !socket.isConnected) {
      ElMessage.error("未连接到指令服务器!");
      return;
    }

    const msgId = crypto.randomUUID();
    const command = {
      requestId: msgId,
      devNo: selectedDeviceObj.value.devNo,
      devModel: selectedDeviceObj.value.devModel,
      controlType: {
        code: channel.status.code === 1 ? "on" : "off",
        desc: "",
      },
      parameters: {
        devNo: selectedDeviceObj.value.devNo,
        channelNo: channel.channelNo,
        orderId: new Date().getTime(),
        duration: 60,
      },
    };
    controledDevice.set(msgId, selectedDeviceObj.value);
    socket.send(JSON.stringify(command));
  },

  // 一键全开
  batchAllOn() {
    if (!socket || !socket.isConnected) {
      ElMessage.error("未连接到指令服务器!");
      return;
    }
    devChannels.value.forEach((ch) => {
      ch.status.code = 1;
      handler.onSwitchChange(ch);
    });
    ElMessage.success("已发送全开指令");
  },

  // 一键全关
  batchAllOff() {
    if (!socket || !socket.isConnected) {
      ElMessage.error("未连接到指令服务器!");
      return;
    }
    devChannels.value.forEach((ch) => {
      ch.status.code = 0;
      handler.onSwitchChange(ch);
    });
    ElMessage.success("已发送全关指令");
  },

  // 抽屉关闭前回调
  onDrawerClose(done) {
    deviceControlStatus.value = "-";
    done();
  },
};
</script>
